import { useNavigate, useSearch } from '@tanstack/react-router';

import type { NetworkSortDirection, NetworkSortProperty, NetworkStatus } from './model';
import {
  networksRouteSearchSchema,
  parseNetworksRouteSearch,
  serializeNetworksRouteSearch,
} from './networksRouteSearch';

export function useNetworksRouteFilters() {
  const navigate = useNavigate({ from: '/networks/' });
  const search = useSearch({ strict: false });
  const filter = parseNetworksRouteSearch(networksRouteSearchSchema(search));
  const update = (next: typeof filter) => {
    void navigate({ search: serializeNetworksRouteSearch(next), replace: true });
  };
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: NetworkStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
    setSort: (sortProperty: NetworkSortProperty | null, sortDirection: NetworkSortDirection) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}
